<template>
  <div>
    <h3>Not Found</h3>
    <p>The requested page was not found.</p>
  </div>
</template>

<script>
  export default {
    name: 'NotFound',
  }
</script>

<style scoped>
  div {
    text-align: center;
  }
  h1 {
    margin-top: 2rem;
  }
  svg {
    height: 2rem;
    width: 2rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/NotFound.vue